module.exports = __webpack_public_path__ + "static/media/SWSCRC6-51.7311c250.mp3";